
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12361',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12361",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.469",
  "data-fetching-client": "static-1.9698",
  "foundations-components": "static-1.7994",
  "foundations-components-legacy": "static-1.1019",
  "foundations-theming": "static-1.4451",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.82",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8045",
  "hub-http-shared-msw-handlers": "static-1.10034",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11503",
  "I18n": "static-7-hdineen_hubspot-i18n-react-compiler.2",
  "jasmine-runner": "static-1.6495",
  "marketplace-storefront-base": "static-1.12422",
  "quartz": "static-1.7069",
  "react-dlb": "static-1.79",
  "react-rhumb": "static-1.16705",
  "reactive-variable-buffer-atom": "static-1.2890",
  "reporting-testing-lib": "static-1.9617",
  "settings-ui-lib": "static-1.12551",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7192",
  "ui-addon-i18n": "static-1.11180",
  "ui-addon-react-router-dom": "static-1.9573",
  "unified-auth": "static-1.528",
  "unified-auth-core-lib": "static-1.810",
  "usage-tracker": "static-1.7379",
  "usage-tracker-core": "static-1.7229",
  "customer-data-property-utils": "static-1.8122",
  "hub-http": "static-1.6253",
  "integrations-lib": "static-1.16252",
  "marketplace-ui-common": "static-1.19848",
  "property-management-iframe": "static-1.13260",
  "quartz-config": "static-1.847",
  "quartz-core": "static-1.6288",
  "quartz-routing": "static-1.499",
  "quick-fetch": "static-1.3941",
  "react": "static-7.186",
  "rpc-client-utils": "static-1.4684",
  "ts-schema": "static-1.4105",
  "ui-universal-auth": "static-1.9014",
  "UIComponents": "static-3.8449",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3423",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3346",
  "quartz-webpack": "static-1.3293",
  "bend-plugin-quartz-routing": "static-1.147",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4263",
  "floating-ui": "static-1.56",
  "foundations-assets": "static-1.4899",
  "foundations-theming-specialty": "static-1.2167",
  "framer-motion": "static-1.72",
  "hs-story-utils": "static-1.9455",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5369",
  "react-virtualized": "static-2.99",
  "StyleGuideUI": "static-3.487",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.2036",
  "ui-fonts": "static-1.765",
  "ui-images": "static-2.1160",
  "bend-plugin-foundations-theming": "static-1.2934",
  "foundations-theming-base": "static-1.3436",
  "stylex": "static-1.33",
  "HeadJS": "static-2.764",
  "hs-test-utils-bend-plugin": "static-1.3156",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4358",
  "ai-components-ui-library": "static-1.9045",
  "ai-rendering-library": "static-1.10270",
  "chirp-fetch": "static-1.1919",
  "connections-embed-lib": "static-1.1042",
  "copilot-toolkit": "static-1.11208",
  "feedback-loader": "static-1.29350",
  "laboratory-lib": "static-3.7187",
  "marketplace-embed": "static-1.22172",
  "marketplace-ui-details": "static-1.9743",
  "marketplace-ui-reviews": "static-1.19803",
  "marketplace-ui-tracking": "static-1.14018",
  "sanitize-text": "static-1.8174",
  "ui-addon-video-player": "static-1.8734",
  "usage-tracker-multi": "static-1.5793",
  "usage-tracker-session-replay": "static-1.5065",
  "wootric-nps": "static-1.7006",
  "quartz-head": "static-1.734",
  "web-vitals": "static-1.6",
  "apollo-link-hub-http": "static-2.4683",
  "immer": "static-1.33",
  "immerable": "static-1.4185",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2506",
  "reporting-data": "static-1.67684",
  "cssUtils": "static-1.798",
  "flux-actions": "static-1.341",
  "HubStyle": "static-2.11810",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10239",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10397",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7369",
  "icons": "static-2.650",
  "marketplace-ui-apps-core": "static-1.18380",
  "storybook-react": "static-1.33",
  "trellis-story-utils": "static-1.4546",
  "foundations-components-test-utils": "static-1.5477",
  "quartz-i18n": "static-1.744",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.325",
  "microsoft-drive-integration-lib": "static-1.449",
  "slack-ui-library": "static-1.10423",
  "fsm": "static-1.3763",
  "customer-data-objects": "static-1.7705",
  "property-translator": "static-1.5430",
  "hs-locale-management": "static-1.105",
  "frontend-preferences-client": "static-1.7958",
  "hs-promise-utils": "static-1.5622",
  "hubspot-apollo-client": "static-1.4910",
  "integrations-error-boundary-lib": "static-1.13667",
  "integrations-tracking-lib": "static-1.5633",
  "native-integrations-shared-strings": "static-1.7813",
  "reselect": "static-2.16",
  "sanitize": "static-1.4507",
  "superstore": "static-1.4792",
  "ui-shepherd-react": "static-3.10202",
  "ai-settings-ui-library": "static-1.7931",
  "hub-http-janus": "static-1.838",
  "hubspotter-http": "static-1.4676",
  "immutable-less": "static-1.4684",
  "marketplace-ui-client-types": "static-1.17255",
  "nav-meta": "static-1.29752",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10279",
  "ui-addon-upgrades": "static-9.18041",
  "inbound-db-properties-service-client": "static-1.3871",
  "property-management-common": "static-1.5548",
  "ui-addon-iframeable": "static-1.9092",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.744",
  "quartz-test": "static-1.744",
  "quartz-tracking": "static-1.448",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.94",
  "bender-build-tools": "static-1.3227",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21416",
  "ContentUtils": "static-1.68452",
  "customer-data-objects-ui-components": "static-1.13060",
  "sassPrefix": "static-1.156",
  "breeze-onboarding-components": "static-1.84",
  "avatar-components": "static-1.2529",
  "customer-data-filters-ui": "static-1.39905",
  "customer-data-reference-ui-components": "static-1.13197",
  "embedded-academy-lib": "static-1.14443",
  "ExportDialog": "static-6.10415",
  "highlight.js": "static-1.79",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41388",
  "reporting-snowflake": "static-1.56302",
  "reporting-ui-components": "static-2.64955",
  "reporting-visualizations": "static-1.59760",
  "ui-addon-teams": "static-1.21598",
  "magpie-lib": "static-1.5571",
  "navigation-components": "static-1.18115",
  "magpie-types": "static-1.5031",
  "simple-logging-lib": "static-1.3082",
  "ai-studio-lib": "static-1.11702",
  "app-governance-lib": "static-1.1627",
  "developer-experience-shared-components": "static-1.10542",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8031",
  "ui-product-approvals": "static-1.28227",
  "ui-tool-access": "static-1.10178",
  "usage-based-billing-components-lib": "static-1.9049",
  "usage-tracker-anonymous": "static-1.5796",
  "usage-tracker-public": "static-1.7190",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3611",
  "persist-promise": "static-1.3730",
  "reference-resolvers": "static-1.8202",
  "ui-extensibility-client-types": "static-1.3955",
  "hubspot-apollo-cache": "static-1.369",
  "universal-page-editor-lib": "static-1.3044",
  "final-form": "static-1.70",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2863",
  "merchandise-lib": "static-1.264",
  "atom": "static-1.5105",
  "purchase-motions-components": "static-1.5974",
  "salesImages": "static-1.525",
  "batch-promise": "static-1.1573",
  "crm-component-utils": "static-1.39157",
  "crm-properties-common-lib": "static-1.5916",
  "customer-data-properties": "static-1.51671",
  "framework-data-schema-resolvers": "static-1.6916",
  "property-value-citations": "static-1.2285",
  "reference-resolvers-lite": "static-1.8126",
  "ui-business-units-lib": "static-1.9087",
  "navigation-messaging": "static-1.7442",
  "hubspotter-http-shared-msw-handlers": "static-1.10032",
  "cms-field-types": "static-1.4843",
  "content-icons-ui": "static-1.2233",
  "customer-data-ui-utilities": "static-1.9857",
  "events-data-lib": "static-1.256",
  "conversations-skeleton-state": "static-1.7279",
  "crm-message-bus": "static-1.43044",
  "customer-data-filters-ui-msw-helpers": "static-1.22340",
  "FormUrlGenerator": "static-2.4750",
  "framework-builder-read-service-client": "static-1.4030",
  "framework-data-schema-quick-fetch": "static-1.6821",
  "multi-account-reference-resolvers": "static-1.1011",
  "onboarding-tours": "static-1.16670",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13767",
  "academy-common-lib": "static-1.13903",
  "content-assistance-lib": "static-1.7797",
  "dashboard-lib": "static-1.81652",
  "file-manager-components": "static-1.23703",
  "getting-started-shared-tasks": "static-1.18529",
  "hubspot-prosemirror": "static-1.18313",
  "hubspot-prosemirror-plugins": "static-1.18305",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19883",
  "share-with-third-party-component-lib": "static-1.8733",
  "ui-addon-draggable": "static-3.4794",
  "ui-asset-management-lib": "static-1.11077",
  "user-context": "static-1.5136",
  "growth-payments-core": "static-1.25462",
  "reporting-plugins": "static-1.10373",
  "reporting-reports": "static-1.67362",
  "idb-keyval": "static-1.44",
  "reactive-lib": "static-1.754",
  "nest": "static-1.261",
  "codemirror": "static-5.95",
  "react-codemirror": "static-1.10657",
  "framework-listing-lib": "static-2.28790",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30787",
  "apps-service-types": "static-1.3910",
  "oauth-service-types": "static-1.4282",
  "ui-product-approvals-common": "static-1.122",
  "onboarding-scopes": "static-1.6492",
  "onboarding-tours-client": "static-1.4884",
  "platform-infra-nav-components": "static-1.7696",
  "subscription-experience-data-types": "static-1.14975",
  "crm-record-cards-service-types": "static-1.3615",
  "location-customization-utils-lib": "static-1.9349",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5977",
  "signup-constants": "static-1.18900",
  "signup-ui-url-generator": "static-2.8084",
  "card-properties-lib": "static-1.44280",
  "commerce-subscription-lib": "static-1.37205",
  "crm-actions": "static-1.6358",
  "crm-cards-sdk": "static-1.43677",
  "customer-data-properties-shared-msw-handlers": "static-1.9361",
  "customer-data-tracking": "static-1.6921",
  "hs-resources": "static-1.188",
  "pulse": "static-1.612",
  "calling-global-api": "static-1.64615",
  "calling-internal-common": "static-1.31333",
  "calling-lifecycle-internal": "static-1.65997",
  "calling-lifecycle-messages": "static-1.58291",
  "commerce-products-lib": "static-1.9676",
  "conditional-properties-service-client": "static-1.3822",
  "crm-links": "static-1.6326",
  "external-options-client-types": "static-1.4184",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4248",
  "meetings-icalendar-utils-lib": "static-1.663",
  "multi-currency-client-types": "static-1.3716",
  "object-builder-ui-client": "static-1.48842",
  "pipeline-validation-client-types": "static-1.3990",
  "smart-property-lib": "static-1.7242",
  "tiered-pricing": "static-1.1282",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11021",
  "crm-pipelines-api-client-types": "static-1.4164",
  "fdsr-migration-layer": "static-1.35",
  "react-dnd-compat": "static-1.4646",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.978",
  "growth-data-modal": "static-1.5474",
  "growth-onboarding-confetti": "static-1.3098",
  "growth-onboarding-next-action-utils": "static-1.2004",
  "onboarding-tours-utils": "static-1.736",
  "ui-shepherd-tracker": "static-1.7583",
  "academy-service-client": "static-1.3713",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39202",
  "FileManagerLib": "static-1.39343",
  "video-embed": "static-1.35876",
  "ui-coaching-tips": "static-1.28642",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11384",
  "video-data-lib": "static-1.35042",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8503",
  "payment-link-components": "static-1.23622",
  "ui-addon-emoji-picker": "static-1.9919",
  "EmailSignatureEditor": "static-1.24436",
  "viral-links-lib": "static-1.7098",
  "data-token-picker": "static-1.16458",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.257",
  "timezone-utils": "static-2.5276",
  "seat-types-lib": "static-1.81",
  "getting-started-shared-tasks-store": "static-1.17647",
  "ui-addon-opt": "static-4.8395",
  "campaign-roi-lib": "static-1.9203",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7357",
  "customer-data-views-management": "static-1.25525",
  "framework-data-table": "static-2.11982",
  "marketing-platform-lib": "static-1.6889",
  "nudge-client-utils": "static-1.2642",
  "nudge-custom-ui-functions": "static-1.1079",
  "app-users-service-client": "static-1.5629",
  "app-users-service-types": "static-1.5037",
  "mini-checkout-client": "static-1.26878",
  "onboarding-utils": "static-1.5385",
  "permissions-shared-i18n-strings-fe": "static-1.2046",
  "ui-coaching-tips-shared-config": "static-1.28627",
  "edison-service-client-types": "static-1.420",
  "crm_data": "static-4.92053",
  "customer-data-sidebar": "static-2.46100",
  "enrichment-properties-lib": "static-1.16360",
  "ui-addon-draggable-compat": "static-2.4288",
  "commerce-billing-lib": "static-1.19170",
  "commerce-shared-components-lib": "static-1.18620",
  "commerce-tools-ui-lib": "static-1.10456",
  "crm-fe-perf": "static-1.22935",
  "bend-plugin-pulse": "static-1.115",
  "event-emitter": "static-1.979",
  "fast-json-patch": "static-1.63",
  "calling-error-reporting": "static-1.31340",
  "shared-worker-versioning": "static-1.11068",
  "calling-usage-tracker": "static-1.6572",
  "voice-sms-access-library": "static-1.1103",
  "commerce-permissions": "static-1.803",
  "products-iframe-lib": "static-1.8018",
  "products-ui-components-shared-msw-handlers": "static-1.10416",
  "data-agent-kit": "static-1.241",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10117",
  "policy-lib": "static-1.6808",
  "react-tinymce": "static-1.55327",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10180",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54453",
  "tinymce-plugins": "static-1.57567",
  "tinymce-themes": "static-1.56423",
  "onboarding-data-sync-lib": "static-1.2003",
  "growth-onboarding-next-action-components": "static-1.2032",
  "user-context-client": "static-1.4643",
  "audio-components": "static-1.5960",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36854",
  "urlinator": "static-1.4568",
  "video-components": "static-1.13387",
  "outpost": "static-1.4209",
  "growth-onboarding-feedback-components": "static-1.6611",
  "content-media-composition-data-lib": "static-1.12428",
  "content-media-compositions": "static-2.16435",
  "media-bridge-lib": "static-1.18976",
  "commerce-tours-lib": "static-1.6157",
  "growth-onboarding-reliability": "static-1.5113",
  "sales-checkout-service-client": "static-1.3673",
  "draft-convert": "static-2.73",
  "draft-extend": "static-3.75",
  "draft-js": "static-5.78",
  "draft-plugins": "static-2.21726",
  "sales-email-signature-service-client": "static-1.3875",
  "ts-utils-lib": "static-1.203",
  "breeze-engine-lib": "static-1.744",
  "crm-export-dialog": "static-1.6320",
  "crm-index-associations-lib": "static-1.6471",
  "crm-view-components": "static-1.356",
  "react-beautiful-dnd": "static-1.13",
  "tanstack-virtual": "static-1.30",
  "nudge-custom-function-registry": "static-1.2399",
  "nudge-renderer-utils": "static-1.2718",
  "whisper-core-api": "static-1.6705",
  "InboxConnectUtils": "static-4.14896",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5620",
  "settings-content-modals": "static-1.46169",
  "crm_universal": "static-1.22057",
  "customer-data-email": "static-1.18084",
  "card-payment-highlight-lib": "static-1.37261",
  "card-subscription-highlight-lib": "static-1.39628",
  "commerce-contract-lib": "static-1.12194",
  "invoices-highlight-card-lib": "static-1.54820",
  "orders-highlight-card-lib": "static-1.21551",
  "products-highlight-card-lib": "static-1.17959",
  "quotes-highlight-card-lib": "static-1.72144",
  "crm-source-interpretation-lib": "static-1.5374",
  "utility-belt": "static-1.2565",
  "payments-enrollment-embed-lib": "static-1.22985",
  "stripe-embedded-components": "static-1.7556",
  "customer-data-rte": "static-1.33076",
  "cv-backend-services": "static-1.1553",
  "growth-onboarding-empty-states": "static-1.5787",
  "payments-post-enroll-local-storage-lib": "static-1.5140",
  "qrcode-generator": "static-1.69",
  "quotes-client-types": "static-1.38234",
  "trials-service-types": "static-1.3935",
  "calling-orchestration-schema": "static-1.35880",
  "sales-views-client-types": "static-1.4290",
  "hub-http-contrib": "static-1.3073",
  "interframe": "static-3.4791",
  "tinymce-data": "static-1.40538",
  "ui-addon-sales-email": "static-1.5242",
  "layout-dnd-components": "static-1.12500",
  "layout-dnd-utils": "static-1.11475",
  "ui-brand-identity-lib": "static-1.15409",
  "NamespacedHubStyle": "static-2.9083",
  "meetings-connect-utils-lib": "static-1.7636",
  "social-insights-client-types": "static-1.22193",
  "js-cookie": "static-1.18",
  "ably": "static-2.2",
  "crm-index-visualization-core": "static-1.4177",
  "checkout-sdk": "static-3.23721",
  "checkout-service-types": "static-1.3846",
  "company-details-components": "static-1.6227",
  "payment-method-components": "static-1.6931",
  "pricing-pages-ui-components": "static-1.14162",
  "quote-checkout-service-types": "static-1.3500",
  "upgrade-catalog-service-types": "static-1.3551",
  "access-control-lib": "static-1.10467",
  "EmailComponents": "static-1.54835",
  "EmailData": "static-1.53512",
  "redux-less": "static-2.9515",
  "sequences-lib": "static-1.8092",
  "ui-gdpr-components": "static-1.10382",
  "products-ui-components": "static-1.40194",
  "accounting-integrations-ui-components": "static-1.7110",
  "invoices-ui-lib": "static-1.54836",
  "commerce-products-api": "static-1.2341",
  "invoices-iframe-lib": "static-1.56894",
  "quotes-modal-lib": "static-1.102822",
  "quotes-ui-lib": "static-1.80865",
  "stripe-connect-js": "static-1.69",
  "draft-content-plugins": "static-1.28348",
  "ContentData": "static-1.68527",
  "layout-data-lib": "static-1.9800",
  "hub-http-rxjs": "static-1.804",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3970",
  "billing-payments-client-types": "static-1.4021",
  "react-performance-metrics-lib": "static-1.587",
  "account-and-billing-fintech-outages": "static-3.18629",
  "pricing-pages-api": "static-1.14027",
  "ContentComponents": "static-2.71408",
  "marketing-contacts-lib": "static-1.10144",
  "marketing-email-service-types": "static-1.1926",
  "messaging-editing-lib": "static-1.46359",
  "messaging-usage-based-billing-components-lib": "static-1.1221",
  "automation-ui-source-apps": "static-1.18976",
  "automation-ui-types": "static-1.19894",
  "messaging-types-lib": "static-1.46096",
  "onboarding-settings-client": "static-1.4536",
  "sequences-client-types-lib": "static-1.7949",
  "commerce-tax-lib": "static-1.558",
  "price-books-api": "static-1.888",
  "price-books-components": "static-1.946",
  "property-description-translator": "static-1.3874",
  "ramp-editor": "static-1.216",
  "commerce-analytics-service-client": "static-1.3661",
  "totals-ui-components": "static-1.23686",
  "SalesContentIndexUI": "static-3.9295",
  "advanced-menus-core": "static-1.15174",
  "advanced-menus-lib": "static-1.12112",
  "ui-memberships-settings-lib": "static-1.34127",
  "segments-query-core": "static-1.1450",
  "demographics-service-types": "static-1.1684",
  "eligibility-engine-service-types": "static-1.3216",
  "automation-ui-ubb": "static-1.5810",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7370",
  "data-token-views": "static-1.16439",
  "forms-utils-lib": "static-1.12639",
  "payments-embed-points-lib": "static-1.13097",
  "simple-menus-core": "static-1.15173",
  "simple-menus-lib": "static-1.16690",
  "videoconference-integration-components": "static-1.6864",
  "marketing-contacts-client": "static-1.7548",
  "automation-applications-service-types": "static-1.3541",
  "automation-platform-service-types": "static-1.2598",
  "ContentEditorUI": "static-2.77191",
  "short-messages-app-service-client": "static-1.4000",
  "web-interactives-components": "static-1.13809",
  "web-interactives-data": "static-1.13810",
  "messaging-shared-utils-lib": "static-1.670",
  "messaging-user-info-utils-lib": "static-1.840",
  "email-portal-health-service-types": "static-1.1009",
  "line-items-api": "static-1.741",
  "commerce-totals-service-types": "static-1.3844",
  "FireAlarmUi": "static-1.4537",
  "sales-templates-service-types-lib": "static-1.4195",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21830",
  "automation-ui-usage-tracking": "static-1.21293",
  "data-studio-ubb": "static-1.2811",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27102",
  "collaboration-sidebar": "static-1.57916",
  "content-management-data-lib": "static-1.5428",
  "copilot-plugins": "static-1.11181",
  "cta-picker": "static-1.36484",
  "customer-agent-discovery-components-lib": "static-1.3168",
  "editor-components": "static-1.13271",
  "editor-iframe-lib": "static-1.8445",
  "error-messaging-js": "static-1.5224",
  "FormsCommonComponents": "static-1.85934",
  "pictos": "static-7.184",
  "react-transition-group": "static-2.65",
  "redux-request-state": "static-1.10676",
  "SharedLegalStrings": "static-1.1778",
  "smart-content-core": "static-1.42527",
  "smart-content-lib": "static-1.43180",
  "social-composer-lib": "static-1.59287",
  "structured-content-lib": "static-1.25272",
  "theme-previewer-lib": "static-1.53319",
  "tinymce-copilot": "static-1.16521",
  "xray-recommendation-lib": "static-1.7950",
  "automation-ui-routing": "static-1.21251",
  "sql-reporting-client-types": "static-1.5657",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42263",
  "campaigns-utils-lib": "static-1.3213",
  "reporting-enablement": "static-1.23024",
  "chatspot-widget-iframe": "static-1.21407",
  "collaboration-sidebar-common": "static-1.2713",
  "forms-ai-lib": "static-1.4363",
  "codemirror-dlb": "static-1.58750",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6463",
  "report-customization-components": "static-1.13258",
  "data-quality-ui-library": "static-1.13124",
  "html-to-image": "static-1.54",
  "reporting-filters": "static-1.401",
  "reporting-insights-lib": "static-1.1833"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12361",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.469",
  "data-fetching-client": "/data-fetching-client/static-1.9698",
  "foundations-components": "/foundations-components/static-1.7994",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1019",
  "foundations-theming": "/foundations-theming/static-1.4451",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.82",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8045",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10034",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11503",
  "I18n": "/I18n/static-7-hdineen_hubspot-i18n-react-compiler.2",
  "jasmine-runner": "/jasmine-runner/static-1.6495",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12422",
  "quartz": "/quartz/static-1.7069",
  "react-dlb": "/react-dlb/static-1.79",
  "react-rhumb": "/react-rhumb/static-1.16705",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2890",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9617",
  "settings-ui-lib": "/settings-ui-lib/static-1.12551",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7192",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11180",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9573",
  "unified-auth": "/unified-auth/static-1.528",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.810",
  "usage-tracker": "/usage-tracker/static-1.7379",
  "usage-tracker-core": "/usage-tracker-core/static-1.7229",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8122",
  "hub-http": "/hub-http/static-1.6253",
  "integrations-lib": "/integrations-lib/static-1.16252",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19848",
  "property-management-iframe": "/property-management-iframe/static-1.13260",
  "quartz-config": "/quartz-config/static-1.847",
  "quartz-core": "/quartz-core/static-1.6288",
  "quartz-routing": "/quartz-routing/static-1.499",
  "quick-fetch": "/quick-fetch/static-1.3941",
  "react": "/react/static-7.186",
  "rpc-client-utils": "/rpc-client-utils/static-1.4684",
  "ts-schema": "/ts-schema/static-1.4105",
  "ui-universal-auth": "/ui-universal-auth/static-1.9014",
  "UIComponents": "/UIComponents/static-3.8449",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3423",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3346",
  "quartz-webpack": "/quartz-webpack/static-1.3293",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.147",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4263",
  "floating-ui": "/floating-ui/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4899",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2167",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-story-utils": "/hs-story-utils/static-1.9455",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5369",
  "react-virtualized": "/react-virtualized/static-2.99",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.2036",
  "ui-fonts": "/ui-fonts/static-1.765",
  "ui-images": "/ui-images/static-2.1160",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2934",
  "foundations-theming-base": "/foundations-theming-base/static-1.3436",
  "stylex": "/stylex/static-1.33",
  "HeadJS": "/HeadJS/static-2.764",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3156",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4358",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9045",
  "ai-rendering-library": "/ai-rendering-library/static-1.10270",
  "chirp-fetch": "/chirp-fetch/static-1.1919",
  "connections-embed-lib": "/connections-embed-lib/static-1.1042",
  "copilot-toolkit": "/copilot-toolkit/static-1.11208",
  "feedback-loader": "/feedback-loader/static-1.29350",
  "laboratory-lib": "/laboratory-lib/static-3.7187",
  "marketplace-embed": "/marketplace-embed/static-1.22172",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9743",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19803",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14018",
  "sanitize-text": "/sanitize-text/static-1.8174",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8734",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5793",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5065",
  "wootric-nps": "/wootric-nps/static-1.7006",
  "quartz-head": "/quartz-head/static-1.734",
  "web-vitals": "/web-vitals/static-1.6",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4683",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4185",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2506",
  "reporting-data": "/reporting-data/static-1.67684",
  "cssUtils": "/cssUtils/static-1.798",
  "flux-actions": "/flux-actions/static-1.341",
  "HubStyle": "/HubStyle/static-2.11810",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10239",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10397",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7369",
  "icons": "/icons/static-2.650",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18380",
  "storybook-react": "/storybook-react/static-1.33",
  "trellis-story-utils": "/trellis-story-utils/static-1.4546",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5477",
  "quartz-i18n": "/quartz-i18n/static-1.744",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.325",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.449",
  "slack-ui-library": "/slack-ui-library/static-1.10423",
  "fsm": "/fsm/static-1.3763",
  "customer-data-objects": "/customer-data-objects/static-1.7705",
  "property-translator": "/property-translator/static-1.5430",
  "hs-locale-management": "/hs-locale-management/static-1.105",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7958",
  "hs-promise-utils": "/hs-promise-utils/static-1.5622",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4910",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13667",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5633",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7813",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4507",
  "superstore": "/superstore/static-1.4792",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10202",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7931",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "hubspotter-http": "/hubspotter-http/static-1.4676",
  "immutable-less": "/immutable-less/static-1.4684",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17255",
  "nav-meta": "/nav-meta/static-1.29752",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10279",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18041",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3871",
  "property-management-common": "/property-management-common/static-1.5548",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9092",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.744",
  "quartz-test": "/quartz-test/static-1.744",
  "quartz-tracking": "/quartz-tracking/static-1.448",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.94",
  "bender-build-tools": "/bender-build-tools/static-1.3227",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21416",
  "ContentUtils": "/ContentUtils/static-1.68452",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13060",
  "sassPrefix": "/sassPrefix/static-1.156",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.84",
  "avatar-components": "/avatar-components/static-1.2529",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39905",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13197",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14443",
  "ExportDialog": "/ExportDialog/static-6.10415",
  "highlight.js": "/highlight.js/static-1.79",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41388",
  "reporting-snowflake": "/reporting-snowflake/static-1.56302",
  "reporting-ui-components": "/reporting-ui-components/static-2.64955",
  "reporting-visualizations": "/reporting-visualizations/static-1.59760",
  "ui-addon-teams": "/ui-addon-teams/static-1.21598",
  "magpie-lib": "/magpie-lib/static-1.5571",
  "navigation-components": "/navigation-components/static-1.18115",
  "magpie-types": "/magpie-types/static-1.5031",
  "simple-logging-lib": "/simple-logging-lib/static-1.3082",
  "ai-studio-lib": "/ai-studio-lib/static-1.11702",
  "app-governance-lib": "/app-governance-lib/static-1.1627",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10542",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8031",
  "ui-product-approvals": "/ui-product-approvals/static-1.28227",
  "ui-tool-access": "/ui-tool-access/static-1.10178",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9049",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5796",
  "usage-tracker-public": "/usage-tracker-public/static-1.7190",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3611",
  "persist-promise": "/persist-promise/static-1.3730",
  "reference-resolvers": "/reference-resolvers/static-1.8202",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3955",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.369",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3044",
  "final-form": "/final-form/static-1.70",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2863",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "atom": "/atom/static-1.5105",
  "purchase-motions-components": "/purchase-motions-components/static-1.5974",
  "salesImages": "/salesImages/static-1.525",
  "batch-promise": "/batch-promise/static-1.1573",
  "crm-component-utils": "/crm-component-utils/static-1.39157",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5916",
  "customer-data-properties": "/customer-data-properties/static-1.51671",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6916",
  "property-value-citations": "/property-value-citations/static-1.2285",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8126",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9087",
  "navigation-messaging": "/navigation-messaging/static-1.7442",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10032",
  "cms-field-types": "/cms-field-types/static-1.4843",
  "content-icons-ui": "/content-icons-ui/static-1.2233",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9857",
  "events-data-lib": "/events-data-lib/static-1.256",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7279",
  "crm-message-bus": "/crm-message-bus/static-1.43044",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22340",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4750",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4030",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6821",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1011",
  "onboarding-tours": "/onboarding-tours/static-1.16670",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13767",
  "academy-common-lib": "/academy-common-lib/static-1.13903",
  "content-assistance-lib": "/content-assistance-lib/static-1.7797",
  "dashboard-lib": "/dashboard-lib/static-1.81652",
  "file-manager-components": "/file-manager-components/static-1.23703",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18529",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18313",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18305",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19883",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8733",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4794",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11077",
  "user-context": "/user-context/static-1.5136",
  "growth-payments-core": "/growth-payments-core/static-1.25462",
  "reporting-plugins": "/reporting-plugins/static-1.10373",
  "reporting-reports": "/reporting-reports/static-1.67362",
  "idb-keyval": "/idb-keyval/static-1.44",
  "reactive-lib": "/reactive-lib/static-1.754",
  "nest": "/nest/static-1.261",
  "codemirror": "/codemirror/static-5.95",
  "react-codemirror": "/react-codemirror/static-1.10657",
  "framework-listing-lib": "/framework-listing-lib/static-2.28790",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30787",
  "apps-service-types": "/apps-service-types/static-1.3910",
  "oauth-service-types": "/oauth-service-types/static-1.4282",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.122",
  "onboarding-scopes": "/onboarding-scopes/static-1.6492",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4884",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7696",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14975",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3615",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9349",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5977",
  "signup-constants": "/signup-constants/static-1.18900",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8084",
  "card-properties-lib": "/card-properties-lib/static-1.44280",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37205",
  "crm-actions": "/crm-actions/static-1.6358",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43677",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9361",
  "customer-data-tracking": "/customer-data-tracking/static-1.6921",
  "hs-resources": "/hs-resources/static-1.188",
  "pulse": "/pulse/static-1.612",
  "calling-global-api": "/calling-global-api/static-1.64615",
  "calling-internal-common": "/calling-internal-common/static-1.31333",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65997",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58291",
  "commerce-products-lib": "/commerce-products-lib/static-1.9676",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3822",
  "crm-links": "/crm-links/static-1.6326",
  "external-options-client-types": "/external-options-client-types/static-1.4184",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4248",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.663",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3716",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48842",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3990",
  "smart-property-lib": "/smart-property-lib/static-1.7242",
  "tiered-pricing": "/tiered-pricing/static-1.1282",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11021",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4164",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.35",
  "react-dnd-compat": "/react-dnd-compat/static-1.4646",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.978",
  "growth-data-modal": "/growth-data-modal/static-1.5474",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3098",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2004",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.736",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7583",
  "academy-service-client": "/academy-service-client/static-1.3713",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39202",
  "FileManagerLib": "/FileManagerLib/static-1.39343",
  "video-embed": "/video-embed/static-1.35876",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28642",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11384",
  "video-data-lib": "/video-data-lib/static-1.35042",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8503",
  "payment-link-components": "/payment-link-components/static-1.23622",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9919",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24436",
  "viral-links-lib": "/viral-links-lib/static-1.7098",
  "data-token-picker": "/data-token-picker/static-1.16458",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.257",
  "timezone-utils": "/timezone-utils/static-2.5276",
  "seat-types-lib": "/seat-types-lib/static-1.81",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17647",
  "ui-addon-opt": "/ui-addon-opt/static-4.8395",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9203",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7357",
  "customer-data-views-management": "/customer-data-views-management/static-1.25525",
  "framework-data-table": "/framework-data-table/static-2.11982",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6889",
  "nudge-client-utils": "/nudge-client-utils/static-1.2642",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1079",
  "app-users-service-client": "/app-users-service-client/static-1.5629",
  "app-users-service-types": "/app-users-service-types/static-1.5037",
  "mini-checkout-client": "/mini-checkout-client/static-1.26878",
  "onboarding-utils": "/onboarding-utils/static-1.5385",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2046",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28627",
  "edison-service-client-types": "/edison-service-client-types/static-1.420",
  "crm_data": "/crm_data/static-4.92053",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46100",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16360",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4288",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19170",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18620",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10456",
  "crm-fe-perf": "/crm-fe-perf/static-1.22935",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.115",
  "event-emitter": "/event-emitter/static-1.979",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "calling-error-reporting": "/calling-error-reporting/static-1.31340",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11068",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6572",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1103",
  "commerce-permissions": "/commerce-permissions/static-1.803",
  "products-iframe-lib": "/products-iframe-lib/static-1.8018",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10416",
  "data-agent-kit": "/data-agent-kit/static-1.241",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10117",
  "policy-lib": "/policy-lib/static-1.6808",
  "react-tinymce": "/react-tinymce/static-1.55327",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10180",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54453",
  "tinymce-plugins": "/tinymce-plugins/static-1.57567",
  "tinymce-themes": "/tinymce-themes/static-1.56423",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2003",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2032",
  "user-context-client": "/user-context-client/static-1.4643",
  "audio-components": "/audio-components/static-1.5960",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36854",
  "urlinator": "/urlinator/static-1.4568",
  "video-components": "/video-components/static-1.13387",
  "outpost": "/outpost/static-1.4209",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6611",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12428",
  "content-media-compositions": "/content-media-compositions/static-2.16435",
  "media-bridge-lib": "/media-bridge-lib/static-1.18976",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6157",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5113",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3673",
  "draft-convert": "/draft-convert/static-2.73",
  "draft-extend": "/draft-extend/static-3.75",
  "draft-js": "/draft-js/static-5.78",
  "draft-plugins": "/draft-plugins/static-2.21726",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3875",
  "ts-utils-lib": "/ts-utils-lib/static-1.203",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.744",
  "crm-export-dialog": "/crm-export-dialog/static-1.6320",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6471",
  "crm-view-components": "/crm-view-components/static-1.356",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.30",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2399",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2718",
  "whisper-core-api": "/whisper-core-api/static-1.6705",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14896",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5620",
  "settings-content-modals": "/settings-content-modals/static-1.46169",
  "crm_universal": "/crm_universal/static-1.22057",
  "customer-data-email": "/customer-data-email/static-1.18084",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37261",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39628",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12194",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54820",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21551",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17959",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72144",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5374",
  "utility-belt": "/utility-belt/static-1.2565",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22985",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7556",
  "customer-data-rte": "/customer-data-rte/static-1.33076",
  "cv-backend-services": "/cv-backend-services/static-1.1553",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5787",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5140",
  "qrcode-generator": "/qrcode-generator/static-1.69",
  "quotes-client-types": "/quotes-client-types/static-1.38234",
  "trials-service-types": "/trials-service-types/static-1.3935",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35880",
  "sales-views-client-types": "/sales-views-client-types/static-1.4290",
  "hub-http-contrib": "/hub-http-contrib/static-1.3073",
  "interframe": "/interframe/static-3.4791",
  "tinymce-data": "/tinymce-data/static-1.40538",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5242",
  "layout-dnd-components": "/layout-dnd-components/static-1.12500",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11475",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15409",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9083",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7636",
  "social-insights-client-types": "/social-insights-client-types/static-1.22193",
  "js-cookie": "/js-cookie/static-1.18",
  "ably": "/ably/static-2.2",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4177",
  "checkout-sdk": "/checkout-sdk/static-3.23721",
  "checkout-service-types": "/checkout-service-types/static-1.3846",
  "company-details-components": "/company-details-components/static-1.6227",
  "payment-method-components": "/payment-method-components/static-1.6931",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14162",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3500",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3551",
  "access-control-lib": "/access-control-lib/static-1.10467",
  "EmailComponents": "/EmailComponents/static-1.54835",
  "EmailData": "/EmailData/static-1.53512",
  "redux-less": "/redux-less/static-2.9515",
  "sequences-lib": "/sequences-lib/static-1.8092",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10382",
  "products-ui-components": "/products-ui-components/static-1.40194",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7110",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54836",
  "commerce-products-api": "/commerce-products-api/static-1.2341",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56894",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102822",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80865",
  "stripe-connect-js": "/stripe-connect-js/static-1.69",
  "draft-content-plugins": "/draft-content-plugins/static-1.28348",
  "ContentData": "/ContentData/static-1.68527",
  "layout-data-lib": "/layout-data-lib/static-1.9800",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.804",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3970",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4021",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.587",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18629",
  "pricing-pages-api": "/pricing-pages-api/static-1.14027",
  "ContentComponents": "/ContentComponents/static-2.71408",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10144",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1926",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46359",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1221",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18976",
  "automation-ui-types": "/automation-ui-types/static-1.19894",
  "messaging-types-lib": "/messaging-types-lib/static-1.46096",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4536",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7949",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.558",
  "price-books-api": "/price-books-api/static-1.888",
  "price-books-components": "/price-books-components/static-1.946",
  "property-description-translator": "/property-description-translator/static-1.3874",
  "ramp-editor": "/ramp-editor/static-1.216",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3661",
  "totals-ui-components": "/totals-ui-components/static-1.23686",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9295",
  "advanced-menus-core": "/advanced-menus-core/static-1.15174",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12112",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34127",
  "segments-query-core": "/segments-query-core/static-1.1450",
  "demographics-service-types": "/demographics-service-types/static-1.1684",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3216",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5810",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7370",
  "data-token-views": "/data-token-views/static-1.16439",
  "forms-utils-lib": "/forms-utils-lib/static-1.12639",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13097",
  "simple-menus-core": "/simple-menus-core/static-1.15173",
  "simple-menus-lib": "/simple-menus-lib/static-1.16690",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6864",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7548",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3541",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2598",
  "ContentEditorUI": "/ContentEditorUI/static-2.77191",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4000",
  "web-interactives-components": "/web-interactives-components/static-1.13809",
  "web-interactives-data": "/web-interactives-data/static-1.13810",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.670",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.840",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1009",
  "line-items-api": "/line-items-api/static-1.741",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3844",
  "FireAlarmUi": "/FireAlarmUi/static-1.4537",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4195",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21830",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21293",
  "data-studio-ubb": "/data-studio-ubb/static-1.2811",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27102",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57916",
  "content-management-data-lib": "/content-management-data-lib/static-1.5428",
  "copilot-plugins": "/copilot-plugins/static-1.11181",
  "cta-picker": "/cta-picker/static-1.36484",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3168",
  "editor-components": "/editor-components/static-1.13271",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8445",
  "error-messaging-js": "/error-messaging-js/static-1.5224",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85934",
  "pictos": "/pictos/static-7.184",
  "react-transition-group": "/react-transition-group/static-2.65",
  "redux-request-state": "/redux-request-state/static-1.10676",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1778",
  "smart-content-core": "/smart-content-core/static-1.42527",
  "smart-content-lib": "/smart-content-lib/static-1.43180",
  "social-composer-lib": "/social-composer-lib/static-1.59287",
  "structured-content-lib": "/structured-content-lib/static-1.25272",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53319",
  "tinymce-copilot": "/tinymce-copilot/static-1.16521",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7950",
  "automation-ui-routing": "/automation-ui-routing/static-1.21251",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5657",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42263",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3213",
  "reporting-enablement": "/reporting-enablement/static-1.23024",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21407",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2713",
  "forms-ai-lib": "/forms-ai-lib/static-1.4363",
  "codemirror-dlb": "/codemirror-dlb/static-1.58750",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6463",
  "report-customization-components": "/report-customization-components/static-1.13258",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13124",
  "html-to-image": "/html-to-image/static-1.54",
  "reporting-filters": "/reporting-filters/static-1.401",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1833"
}
};
